import { RootState, RootActions } from "common/reducers";
import { Record, List } from "immutable";
import { FeneTechListQuoteRecord, feneTechListQuoteFromJSON } from "common/records/FeneTechListQuoteRecord";
import { FeneTechQuoteFullRecord, feneTechQuoteFullFromJSON } from "common/records/FeneTechQuoteFullRecord";
import {
  SET_FENETECH_LOADING,
  RECEIVE_FENETECH_QUOTES,
  RECEIVE_FENETECH_QUOTE,
  RESET_FENETECH_STATE,
  OPEN_FENETECH_MODAL,
} from "common/reducers/fenetech.actions";

// `modalManufacturerId` uses `undefined` as the "not open" sentinel because `null` is a valid
// value meaning "FeneVision WEB fallback clicked". The modal is shown when
// `modalEstimateGroupId !== null` — not based on `modalManufacturerId`.
export const FeneTechStateRecord = Record({
  loading: false,
  quotes: null as List<FeneTechListQuoteRecord> | null,
  quote: null as FeneTechQuoteFullRecord | null,
  modalManufacturerId: undefined as string | null | undefined,
  modalEstimateGroupId: null as number | null,
});

export const initialState = FeneTechStateRecord();
export type FeneTechState = typeof initialState;

const model = "fenetech";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.getIn([model])) {
    state = state.setIn([model], initialState);
  }
  switch (action.type) {
    case SET_FENETECH_LOADING:
      return state.setIn([model, "loading"], action.payload);
    case RECEIVE_FENETECH_QUOTES:
      return state.setIn([model, "quotes"], List(action.payload.map(feneTechListQuoteFromJSON)));
    case RECEIVE_FENETECH_QUOTE:
      return state.setIn([model, "quote"], feneTechQuoteFullFromJSON(action.payload));
    case RESET_FENETECH_STATE:
      return state.setIn([model], initialState);
    case OPEN_FENETECH_MODAL:
      return state
        .setIn([model, "modalManufacturerId"], action.payload.manufacturerId)
        .setIn([model, "modalEstimateGroupId"], action.payload.estimateGroupId);
    default:
      return state;
  }
};
